<template>
  <div v-if="newUrl">
    <vs-avatar :src="newUrl" />
  </div>
</template>

<script>
export default {
  name: "avatar",
  props: {
    size: {
      type: String,
      required: false
    },
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newUrl: ""
    };
  },
  created() {
    var img = new Image();
    img.src = this.src;
    img.onload = () => {
      const iw = img.width;
      const ih = img.height;
      const { width, height } = this.calculateAspectRatioFit(
        iw,
        ih,
        parseInt(this.size),
        parseInt(this.size)
      );
      // create an off-screen canvas
      var canvas = document.createElement("canvas"),
        ctx = canvas.getContext("2d");

      // set its dimension to target size
      canvas.width = width;
      canvas.height = height;

      // draw source image into the off-screen canvas:
      ctx.drawImage(img, 0, 0, width, height);

      // encode image to data-uri with base64 version of compressed image
      this.newUrl = canvas.toDataURL();
    };
  },
  methods: {}
};
</script>

<style>
</style>
